import buildItemComponent from "../../common/item-component-hoc"

import InsightAreaViewFormActionButtonsWidgetContainer from "./view/InsightAreaViewFormActionButtonsWidgetContainer"
import InsightAreaViewItemContainer from "./view/InsightAreaViewItemContainer"
import InsightAreaEditFormActionButtonsWidgetContainer from "./edit/InsightAreaEditFormActionButtonsWidgetContainer"
import InsightAreaEditItemContainer from "./edit/InsightAreaEditItemContainer"

export default buildItemComponent("insightAreas", {
    view: [
        InsightAreaViewFormActionButtonsWidgetContainer,
        InsightAreaViewItemContainer
    ],
    edit: [
        InsightAreaEditFormActionButtonsWidgetContainer,
        InsightAreaEditItemContainer
    ]
})
